<template>
  <Banner
    icon="md-dangerous-outlined"
    iconClass="text-rose-700/30 !text-xl dark:text-rose-500"
    :variant="variant"
    :bannerClass="'text-sm ' + bannerClass"
    :teleportTo="teleportTo ?? undefined"
    :simple="false"
  >
    <ul v-if="validationErrors" :style="Object.values(validationErrors).length > 1 ? {listStyle: 'disc', marginLeft: '0.825rem'} : {}">
      <template v-for="(fieldErrors, index) in limitedErrors(Object.values(validationErrors))" :key="index">
        <li v-for="(error, index) in fieldErrors" :key="index">
          {{ error }}
        </li>
      </template>
    </ul>
    <div v-else-if="extensionErrors">
      {{ extensionErrors }}
    </div>
  </Banner>
</template>

<script setup>
import { ref, watch } from 'vue';
import Banner from "@/components/common/Banner.vue";

const props = defineProps({
  errors: {
    type: Object,
    required: true,
  },
  bannerClass: {
    type: String,
    default: '',
  },
  teleportTo: {
    type: String,
  },
  allowClose: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String,
    default: 'error',
  },
  maxErrors: {
    type: Number
  }
});

const limitedErrors = (errors) => {
  if(! props.maxErrors){
    return errors;
  }
  
  return errors.slice(0, props.maxErrors);
}

const validationErrors = ref(null);
const extensionErrors = ref(null);

const getExtensionErrors = (errors) => {
  if (!errors.extensions || !errors.extensions.reason) {
    return null;
  }
  return `${errors.extensions.reason}`;
};

watch(
  () => props.errors,
  (newErrors) => {
    validationErrors.value = newErrors.validation;
    extensionErrors.value = getExtensionErrors(newErrors);
  },
  { deep: true, immediate: true }
);
</script>

<style></style>